/**
 * Shared color definitions for web dashboards
 * Extracted from tailwind.config.js files
 */

export const colors = {
  primary: {
    50: '#3453D914',
    100: '#DEE6FB',
    200: '#C5D6F8',
    300: '#9CBBF4',
    400: '#6E96EC',
    500: '#4C73E5',
    600: '#3453D9',
    700: '#2E43C7',
    800: '#2B38A2',
    DEFAULT: '#3532A7',
    foreground: '#FFFFFF',
  },
  info: {
    50: '#cafdf5a6',
    100: '#CAFDF5',
    200: '#61F3F3',
    300: '#00B8D9',
    400: '#006C9C',
    500: '#003768',
    DEFAULT: '#00B8D9',
    foreground: '#FFFFFF',
  },
  icons: {
    primary: '#0072DE', // primary color for icons.
    secondary: '#637381', // icons color
    info: '#637381', // Gray-600 color for informational icons
  },
  success: {
    10: '#36B37E1F',
    50: '#D8FBDE',
    100: '#D8FBDE',
    200: '#86E8AB',
    300: '#36B37E',
    400: '#1B806A',
    500: '#0A5554',
    DEFAULT: '#36B37E',
    foreground: '#FFFFFF',
  },
  warning: {
    100: '#FFF5CC',
    200: '#FFD666',
    300: '#F79009',
    400: '#B76E00',
    500: '#7A4100',
    DEFAULT: '#F79009',
    foreground: '#FFFFFF',
  },
  error: {
    20: '#fda29b30',
    50: '#FDA29B4D',
    100: '#FDA29B',
    200: '#F97066',
    300: '#F04438',
    400: '#D92D20',
    500: '#B42318',
    DEFAULT: '#F04438',
    foreground: '#FFFFFF',
  },
  secondary: {
    50: '#EFF6FF',
    100: '#DBEAFE',
    200: '#BFDBFE',
    300: '#93C5FD',
    400: '#60A5FA',
    500: '#3B82F6',
    600: '#2563EB',
    700: '#1D4ED8',
    800: '#1E40AF',
    900: '#1E3A8A',
    DEFAULT: '#2563EB', // blue-600, commonly used for secondary actions
    foreground: '#FFFFFF',
  },
  gray: {
    50: '#F9FAFB',
    100: '#F9FAFB',
    200: '#F4F6F8',
    300: '#DFE3E8',
    400: '#C4CDD5',
    500: '#919EAB',
    600: '#637381',
    700: '#454F5B',
    800: '#212B36',
    900: '#161C24',
  },
  black: '#212636',
  logoBlue: '#3532A7',
  borderColor: '#DFE3E87A',
} as const;

export type Colors = typeof colors;
